import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Coins } from 'lucide-react';
import { api } from '../../lib/api';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';

export default function TipDialog({ open, onOpenChange, targetUsername, onTipped }) {
  const { user, refresh } = useAuth();
  const [amount, setAmount] = useState(50);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const send = async () => {
    const amt = parseInt(amount, 10);
    if (!amt || amt < 1) return toast.error('Enter an amount');
    setLoading(true);
    try {
      await api.post('/tips/send', { to_username: targetUsername, amount: amt, message });
      toast.success(`Sent ${amt} JXP to @${targetUsername} 💜`);
      refresh();
      onOpenChange(false);
      setMessage(''); setAmount(50);
      onTipped?.();
    } catch (e) { toast.error(e.response?.data?.detail || 'Failed'); }
    finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="glass border-white/10 max-w-sm" data-testid="tip-dialog">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2"><Coins className="w-5 h-5 text-amber-400" /> Tip @{targetUsername}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <label className="text-xs text-slate-400 uppercase tracking-wider font-semibold">Amount (JXP)</label>
            <Input data-testid="tip-amount" type="number" min="1" value={amount} onChange={e => setAmount(e.target.value)} />
            <div className="flex gap-1.5 mt-2">
              {[25, 100, 500, 1000].map(v => (
                <button key={v} data-testid={`tip-quick-${v}`} onClick={() => setAmount(v)} className="text-[11px] px-2 py-1 rounded-md bg-white/5 hover:bg-white/10 border border-white/10">{v}</button>
              ))}
            </div>
          </div>
          <div>
            <label className="text-xs text-slate-400 uppercase tracking-wider font-semibold">Message (optional)</label>
            <Textarea data-testid="tip-message" value={message} onChange={e => setMessage(e.target.value)} rows={2} placeholder="Great work!" maxLength={200} />
          </div>
          <div className="text-xs text-slate-400">Your balance: <span className="font-bold text-amber-400">{user?.jxp?.toLocaleString() || 0} JXP</span></div>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button data-testid="tip-send" onClick={send} disabled={loading} className="gradient-brand text-white">
            {loading ? 'Sending…' : `Send ${amount} JXP`}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
